import { Divider, Stack, Typography } from '@mui/material';

import { Strings } from '@app/constants';
import { RHFFilePickerField } from '@app/components';
import { StyledInputs } from '@app/modules/employees/view/styles';
import { IEmployee } from '@app/modules/employees/types';
import { IMyProfileResponse } from '@app/modules/my-profile/types';

// --------------------------------------------
interface props {
  additionalButton?: React.ReactNode;
  title?: string;
  data?: IEmployee | IMyProfileResponse;
  filePickerName?: string;
}
const DocumentsInfoForm = ({ additionalButton, title, data, filePickerName }: props) => {
  const panBackName = data?.panBack ? data.panBack.split('?')[0].split('/').pop() : '';
  const panFrontName = data?.panFront ? data.panFront.split('?')[0].split('/').pop() : '';
  const aadharFrontName = data?.aadharFront ? data.aadharFront.split('?')[0].split('/').pop() : '';
  const aadharBackName = data?.aadharBack ? data.aadharBack.split('?')[0].split('/').pop() : '';
  return (
    <Stack spacing={2} pb={2}>
      <Stack>
        <Typography variant="h5">{Strings.document.documents}</Typography>
      </Stack>
      <Divider />
      <Stack rowGap={2}>
        <StyledInputs>
          <Stack gap={2}>
            <Stack rowGap={2} gap={2} direction="row" flexWrap="wrap">
              <RHFFilePickerField
                name={'documentInfo.aadharFront'}
                label={Strings.document.aadharCardFront}
                multiple
                filePickerName={aadharFrontName}
              />
              <RHFFilePickerField
                name={'documentInfo.aadharBack'}
                label={Strings.document.aadharCardBack}
                multiple
                filePickerName={aadharBackName}
              />
            </Stack>
            <Stack rowGap={2} gap={2} direction="row" flexWrap="wrap">
              <RHFFilePickerField
                name={'documentInfo.panFront'}
                label={Strings.document.panCardFront}
                multiple
                filePickerName={panFrontName}
              />
              <RHFFilePickerField
                name={'documentInfo.panBack'}
                label={Strings.document.panCardBack}
                multiple
                filePickerName={panBackName}
              />
            </Stack>
          </Stack>
          <Stack mt={2}>
            {title === 'intern' && (
              <RHFFilePickerField
                name={'resume'}
                label={Strings.field.resume}
                multiple
                required
                filePickerName={filePickerName}
              />
            )}
          </Stack>
        </StyledInputs>
        <Stack alignItems={'flex-start'}>{additionalButton}</Stack>
      </Stack>
    </Stack>
  );
};

export { DocumentsInfoForm };
